import React from "react";
import { Link } from "react-router-dom";

const RecordingButton = ({ isRecordOn, tempDisabled, onClick }) => {
    return (
        <Link
            to="#"
            className={isRecordOn ? "opcao-gravador-ligado" : "opcao-gravador-desligado"}
            title={isRecordOn ? "Parar Gravação" : "Iniciar Gravação"}
            disabled={tempDisabled}
            onClick={onClick}
        >
            REC
        </Link>
    );
};

export default RecordingButton;
